// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function reorderColumnArray(fromIdx, toIdx, arr) {
  var lst = Belt_List.fromArray(arr);
  var dragged = Belt_List.get(lst, fromIdx);
  if (dragged === undefined) {
    return arr;
  }
  var without = Belt_List.keepWithIndex(lst, (function (param, i) {
          return i !== fromIdx;
        }));
  var match = Belt_List.splitAt(without, toIdx);
  if (match !== undefined) {
    return Belt_List.toArray(Belt_List.concatMany([
                    match[0],
                    {
                      hd: dragged,
                      tl: /* [] */0
                    },
                    match[1]
                  ]));
  } else {
    return arr;
  }
}

function useDragDrop(onReorder) {
  var match = React.useState(function (param) {
        
      });
  var setDraggedLogicIndex = match[1];
  var draggedLogicIndex = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setHoveredLogicIndex = match$1[1];
  var hoveredLogicIndex = match$1[0];
  var handleDragStart = function (index, _e) {
    Curry._1(setDraggedLogicIndex, (function (param) {
            return Caml_option.some(index);
          }));
  };
  var handleDragOver = function (targetIndex, e) {
    e.preventDefault();
    Curry._1(setHoveredLogicIndex, (function (param) {
            return Caml_option.some(targetIndex);
          }));
  };
  var handleDragDrop = function (targetIndex, _e) {
    if (draggedLogicIndex !== undefined) {
      var index = Caml_option.valFromOption(draggedLogicIndex);
      if (Caml_obj.notequal(index, targetIndex)) {
        Curry._2(onReorder, index, targetIndex);
      }
      
    }
    Curry._1(setDraggedLogicIndex, (function (param) {
            
          }));
    Curry._1(setHoveredLogicIndex, (function (param) {
            
          }));
  };
  var getBlurClass = function (index) {
    if (draggedLogicIndex !== undefined && hoveredLogicIndex !== undefined && !(Caml_obj.notequal(Caml_option.valFromOption(draggedLogicIndex), index) && Caml_obj.notequal(Caml_option.valFromOption(hoveredLogicIndex), index))) {
      return "blur-sm opacity-50";
    } else {
      return "";
    }
  };
  return [
          handleDragStart,
          handleDragOver,
          handleDragDrop,
          getBlurClass
        ];
}

exports.reorderColumnArray = reorderColumnArray;
exports.useDragDrop = useDragDrop;
/* react Not a pure module */
